import { useEffect } from "react"
import { notification } from "components/common"
import { fieldMapper } from "../../../../../utils"

export function usePaymentRowEffects({
  fullPath,
  form,
  paymentProof,
  ocrData,
  modeOfPayment,
  paymentModesMap,
  validateReference,
  getBankName,
  getPaymentMode,
  chequeBank,
}) {
  const attachmentType = paymentProof?.imageData?.paymentModeKey

  useEffect(() => {
    const paymentModeMetaId = attachmentType == null ? null : (paymentModesMap?.[attachmentType]?.meta?.id ?? null)

    if (attachmentType != null && paymentModeMetaId != null) {
      getPaymentMode(paymentModeMetaId, true)
    }

    if (!modeOfPayment) return

    const imageData = ocrData?.imageData
    const meta = paymentModesMap?.[modeOfPayment]?.meta
    const rowForm = {
      setFieldsValue: values => {
        Object.keys(values || {}).forEach(k => form.setFieldValue([...fullPath, k], values[k]))
      },
    }

    if (modeOfPayment === "cheque") {
      getBankName({}, true)
      fieldMapper(imageData, meta?.cheque, rowForm)
      if (imageData?.chequeNumber) {
        validateReference({
          referenceNumber: imageData?.chequeNumber,
          bankKey: imageData?.Bank?.key || chequeBank,
          paymentModeKey: modeOfPayment,
        })
          .unwrap()
          .then(() => form.validateFields([[...fullPath, "referenceNumber"]]))
          .catch(e => notification.error({ message: e.message }))
      }
    } else if (modeOfPayment === "online_payment") {
      getBankName({}, true)
      fieldMapper(imageData, meta?.onlinePayment, rowForm)
      form.setFieldValue([...fullPath, "paymentType"], imageData?.onlinePaymentType)
    } else if (modeOfPayment === "card_payment") {
      fieldMapper(imageData, meta?.cardPayment, rowForm)
    } else if (modeOfPayment === "cash") {
      getBankName({}, true)
    } else if (modeOfPayment === "bank_order") {
      getBankName({}, true)
      fieldMapper(imageData, meta?.bankOrder, rowForm)
    }
  }, [
    attachmentType,
    form,
    fullPath,
    getBankName,
    getPaymentMode,
    modeOfPayment,
    ocrData?.imageData,
    paymentModesMap,
    paymentProof?.fileList,
    paymentProof?.name,
    paymentProof?.url,
    validateReference,
  ])
}
